export class ActionsPermission{
  access = 534;
  create = 535;
  delete = 536;
  edit = 537;
  createPost = 538;
  deletePost = 539;
  editPost = 540;
}
